module.exports = __webpack_public_path__ + "static/media/Group.e60cb485.svg";